import type { TooltipStrings } from '@/constants/localization'

export const portfolioTooltips: TooltipStrings = {
  'holding-hedgies': ({ stringGetter, stringParams }) => ({
    title: 'title_portfolio', //stringGetter({ key: TOOLTIP_STRING_KEYS.HOLDING_HEDGIES_TITLE }),
    body: 'body_portfolio', //stringGetter({ key: TOOLTIP_STRING_KEYS.HOLDING_HEDGIES_BODY, params: stringParams }),
  }),
} as const
